import AudienceManagerSaga from 'pages/audienceManager/saga';
import AudienceSaga from 'pages/audienceManager/sagas/audiences';
import CustomAudienceManagerSaga from 'pages/customAudiences/saga';
import GroupSaga from 'pages/audienceManager/sagas/groups';
import LoginSaga from 'pages/auth/saga';

import SearchSaga from 'pages/audienceManager/searchSaga';
import { all, fork } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    fork(AudienceManagerSaga),
    fork(AudienceSaga),
    fork(CustomAudienceManagerSaga),
    fork(GroupSaga),
    fork(LoginSaga),

    fork(SearchSaga),
  ]);
}
